import $ from "jquery"
import _ from "../utils/lodash"
import { getOptions, setOptions } from "./variables"
import xss from "xss"

import { mfp_checkelement, selectedHidden, mfp_setCookie } from "./mfpTootls"
import { openConfirmView } from "./confirmView"

const checkConfimationMode = ({ mailform_confirm_mode }) => {
  if (mailform_confirm_mode) {
    if (
      mailform_confirm_mode.type == "checkbox" &&
      mailform_confirm_mode.checked
    )
      return true
    else if (
      mailform_confirm_mode.type == "hidden" &&
      mailform_confirm_mode.value == 1
    )
      return true
    else return false
  }
  return true
}

export function sendMail(form) {
  //obj.encoding = "multipart/form-data";
  const options = getOptions()
  const { obj, mailformObj, alert_display } = options
  let { confirm_time_val } = options
  const mailform_confirm_mode = checkConfimationMode(form.elements)

  let caution = ""

  let error_element_number = []
  let check_flag = {}
  _.mapValues(obj, (elem, index) => {
    let error_message = ""
    if (!check_flag[elem.name]) error_message = mfp_checkelement(elem)
    check_flag[elem.name] = 1
    if (error_message != "") {
      error_element_number.push(index)
      caution = `${caution}${error_message}\n`
    }
  })

  if (caution == "" && mailform_confirm_mode) {
    if (mailformObj !== undefined) {
      mfp_submit()
    } else {
      confirm_time_val = new Date().getTime() / 1000
      setOptions({ confirm_time_val })
      selectedHidden()

      const texts = processFormValues()
      openConfirmView(texts)
      return false
    }
  } else if (caution == "" && !mailform_confirm_mode) {
    if (confirm(mfp_langObj[mfp_lang][8])) {
      mfp_submit()
    }
  } else {
    caution = mfp_langObj[mfp_lang][9] + "\n" + caution
    if (alert_display) alert(caution)
    obj.elements[error_element_number[0]].focus()
    return false
  }
}

const processTextElement = ({ name, value }) => {
  return {
    name: getName(name).replace("email", mfp_langObj[mfp_lang][12]),
    text: _.escape(xss(value)),
  }
}

const processSelectElement = ({ name, value }) => {
  name = getName(name)
  return {
    name,
    text: _.escape(value),
  }
}

const processRadioElement = ({ name, value, checked }) => {
  const { obj } = getOptions()

  let text = ""

  if (obj.elements[name]?.length > 0) {
    text = _.reduce(
      obj.elements[name],
      (t, opt) => {
        return `${t}${_.escape(opt.value)}<br>`
      },
      ""
    )
  } else if (checked && name !== "mailform_confirm_mode") {
    text = `${_.escape(value)}<br>`
  }

  name = getName(name)

  return { name, text }
}

const processFileElement = ({ name, value }) => {
  name = getName(name)
  let file_element_value = []

  const user_agent = navigator.userAgent.toUpperCase()
  if (user_agent.indexOf("WIN") > -1) file_element_value = value.split("\\")
  else file_element_value = value.split("/")
  return { name, text: file_element_value[file_element_value.length - 1] }
}

const processAllInput = ({ name }) => {
  const { obj } = getOptions()

  let spilitText
  if (name.indexOf("[join]") > -1) spilitText = "[join]"
  else if (name.indexOf("[unjoin]") > -1) spilitText = "[unjoin]"

  const [newName, elements] = name.split(spilitText)

  const text = elements.split("+").reduce((t, element) => {
    if (obj.elements[element]) {
      let { check_flag } = getOptions()
      check_flag[element] = 1
      setOptions({ check_flag })

      return `${t}${_.escape(obj.elements[element].value)}`
    }
    if (/\\n/.test(element)) {
      return `${t}<br>`
    }
    return `${t}${_.escape(element)}`
  }, "")

  return { name: newName, text }
}

const removeMustID = (name) => {
  const { must_id } = getOptions()
  return name.split(must_id)[0]
}

const getName = (name) => {
  const sanitizedName = removeMustID(name)
  return sanitizedName.split("(file)")[0]
}

const processFormValues = () => {
  const { obj } = getOptions()

  return Object.values(
    _.mapValues(obj, (elem) => {
      let { check_flag } = getOptions()
      check_flag = check_flag || {}

      if (!check_flag[elem.name]) {
        check_flag[elem.name] = 1
        setOptions({ check_flag })

        if (
          (elem.type === "text" || elem.type === "textarea") &&
          elem.value !== elem.defaultValue &&
          !/^confirm_email/.test(elem.name)
        ) {
          return processTextElement(elem)
        } else if (
          elem.type === "select-one" &&
          elem.value !== elem.defaultValue &&
          elem.value !== ""
        ) {
          return processSelectElement(elem)
        } else if (elem.type === "radio" || elem.type === "checkbox") {
          return processRadioElement(elem)
        } else if (elem.type === "file" && elem.value !== "") {
          return processFileElement(elem)
        } else if (/\[(un)?join\]/.test(elem.name)) {
          return processAllInput(elem)
        } else if (elem.name === "price") {
          return {
            name: mfp_langObj[mfp_lang][10],
            text: elem.value,
          }
        }
      }
      return false
    })
  ).filter((o) => o)
}

export function mfp_reset(obj) {
  if (confirm(mfp_langObj[mfp_lang][13])) {
    _.mapValues(obj.elements, (element) => {
      if (element.type === "radio" || element.type === "checkbox") {
        element.checked = element.defaultChecked
        if (document.getElementById(element.id + "_label") && !element.checked)
          document.getElementById(element.id + "_label").className =
            "label_false"
      } else if (element.type == "select-one") {
        _.mapValues(element.options, (option) => {
          if (option.defaultSelected) option.selected = true
        })
      } else element.value = element.defaultValue
    })

    _.mapValues(document.getElementsByTagName("div"), (divElem) => {
      if (divElem.className === "mfp_err") divElem.style.display = "none"
    })

    mfp_setCookie("mailform", "")
  }
}

export function figureChecked(figure) {
  const single_char = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "-"]
  const double_char = [
    "０",
    "１",
    "２",
    "３",
    "４",
    "５",
    "６",
    "７",
    "８",
    "９",
    "－",
  ]

  single_char.map((sc, index) => {
    figure = figure.split(double_char[index]).join(single_char[index])
  })

  const figureMatch = figure.match(/[^0-9]/g)
  if (figureMatch) {
    return false
  }
  return figure
}

function mfp_submit() {
  const { obj, must_id, confirm_time_val } = getOptions()
  let check_flag = {}

  if (obj.elements["confirm_time"]) {
    obj.elements["confirm_time"].value =
      Math.floor(new Date().getTime() / 1000 - confirm_time_val) + " sec"
  }
  _.mapValues(obj, (elem) => {
    const elements_name_original = elem.name
    elem.name = removeMustID(elem.name)
    if (elem.type == "file") elem.name += "(file)"
    if (elem.name == "price") elem.name = price_name
    if (check_flag[elements_name_original]) {
      elem.name = ""
      elem.value = ""
    }
    if (elem.type === "text" || elem.type === "textarea") {
      if (elem.value === elem.defaultValue && elem.type !== "hidden") {
        elem.value = ""
      } else {
        elem.value = xss(elem.value)
      }
    }
    if (elem.name.indexOf("[join]") > -1) {
      const joinObj = elements_name_original.split("[join]")
      const printval = joinObj[1].split("+").reduce((pre, name) => {
        if (obj.elements[name]) {
          check_flag[name]
          return `${pre}${obj.elements[value]}`
        }
      }, "")
      elem.name = joinObj[0]
      elem.value = xss(printval)
    }
    if (elem.type == "submit") {
      elem.disabled = true
    }
  })
  const submit = () => {
    setTimeout(() => {
      obj.submit()
    })
  }

  mfp_setCookie("mailform", "")

  if (typeof sendReCaptcha === "function") {
    sendReCaptcha(submit)
  } else {
    submit()
  }
}
